import { render, staticRenderFns } from "./RRPayoffList.vue?vue&type=template&id=fb0ec87e&scoped=true&"
import script from "./RRPayoffList.vue?vue&type=script&lang=js&"
export * from "./RRPayoffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0ec87e",
  null
  
)

export default component.exports